$('document').ready(function () {
  // Logic for taking select input from product page and updating url for button
  var selectWrapper = $('.bh-product-template__select-wrapper');
  var selectElement = $('.bh-product-template__select');
  var selectTrigger = $('.bh-product-template__select-trigger span');
  var selectOption = $('.bh-product-template__select-option');
  var ctaElement = $('.bh-product-template__button-link');
  var productPrice = $('.bh-product__price');

  if (selectWrapper.length) {
    selectWrapper.click(function () {
      selectElement.toggleClass('open');

      var currentSelected = selectOption.filter('.is-selected').text();
      if (selectElement.hasClass('open')) {
        selectTrigger.html('<span>Select a size</span>');
      } else {
        if (currentSelected) {
          selectTrigger.html(currentSelected);
        }
      }
    });

    selectOption.click(function () {
      if (!$(this).hasClass('is-selected')) {
        $('.bh-product-template__select-option.is-selected').removeClass(
          'is-selected'
        );
        $(this).addClass('is-selected');

        selectTrigger.html($(this).text());

        ctaElement.attr('href', $(this).attr('data-size-url'));
        productPrice.html($(this).attr('data-price'));
      }
    });

    window.addEventListener('click', function (e) {
      var select = document.querySelector('.bh-product-template__select');
      var currentSelected = selectOption.filter('.is-selected').text();

      if (!select.contains(e.target) && currentSelected) {
        select.classList.remove('open');
        selectTrigger.html(currentSelected);
      }
    });
  }

  // Testimonial slider with slick
  var testimonialSlider = $('.bh-testimonials__block-wrapper');
  if (testimonialSlider.length) {
    testimonialSlider.slick({
      slidesToShow: 3,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      centerMode: true,
      centerPadding: '70px;',
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
  }

  // Hotfix for images dissapearing after clicking between buttons

  var flickityPrevNext = $('.flickity-prev-next-button');

  if (flickityPrevNext.length) {
    $('<img/>')
      .attr('src', "//nuebynovaform.com/cdn/shop/t/20/assets/icon-image-prev.svg?v=141481238191397282671642615187")
      .appendTo('.flickity-prev-next-button.previous');

    $('<img/>')
      .attr('src', "//nuebynovaform.com/cdn/shop/t/20/assets/icon-image-next.svg?v=101215914535422503011642615186")
      .appendTo('.flickity-prev-next-button.next');

    flickityPrevNext.click(function () {
      var current = $(
        '.Product__SlideItem.Product__SlideItem--hidden.is-selected'
      );
      if (current) {
        current.removeClass('Product__SlideItem--hidden');
      }
    });
  }

  // Email signup. Disable button until input has text
  var signupBtn = $('.bh-signup-input');

  if (signupBtn.length) {
    signupBtn.keyup(function () {
      if (signupBtn.val().trim() !== '') {
        $('.bh-signup__button').attr('disabled', false);
      } else {
        $('.bh-signup__button').attr('disabled', true);
      }
    });
  }

  // Bootstrap accordion on PDP specs/details

  $('.bh-product-template__details-info').on('show.bs.collapse', function () {
    $(this).parent().find('.collapseIcon.plus').addClass('hide');
    $(this).parent().find('.collapseIcon.minus').removeClass('hide');
  });

  $('.bh-product-template__details-info').on('hide.bs.collapse', function () {
    $(this).parent().find('.collapseIcon.plus').removeClass('hide');
    $(this).parent().find('.collapseIcon.minus').addClass('hide');
  });

  // Open/close retailer modal
  var chooseRetailerBtn = $('#open-retailer-modal');
  var modalCloseBtn = $('.bh-modal-content__close');
  var retailerModal = $('.bh-modal');

  chooseRetailerBtn.click(function () {
    retailerModal.css('display', 'block');
    $('body').addClass('body-lock');
  });

  modalCloseBtn.click(function () {
    retailerModal.css('display', 'none');
    $('body').removeClass('body-lock');
  });

  if (retailerModal.length) {
    window.addEventListener('click', function (e) {
      var select = document.querySelector('.bh-modal');

      if (select.contains(e.target)) {
        select.style.display = 'none';
        $('body').removeClass('body-lock');
      }
    });
  }

  //About Us Page Video Feature on the bh-image-text component WIP
  // $(window).scroll(function () {
  //   //will trigger when your element comes into viewport
  //   var hT = $('.bh-image-text').offset().top,
  //     hH = $('.bh-image-text').outerHeight(),
  //     wH = $(window).height(),
  //     wS = $(this).scrollTop();

  //   if (wS > hT + hH - wH) {
  //     var videoUrl = $('#vimeo_player').attr('data-src');

  //     if (!videoUrl.includes('&autoplay=1')) {
  //       $('#vimeo_player').attr('data-src', videoUrl + '&autoplay=1');
  //     }
  //   }
  // });

  // This component has been disabled
  //Landing page newsletter modal closing on click
  // $('.bh-newsletter-modal__close').click(function() {
  //   $('#bh-newsletter-modal').css('display', 'none');
  // })
});
